import { useEffect } from "react";
import "./App.css";
import ComingSoon from "./pages/ComingSoon";

function App() {
  useEffect(() => {
    window.$(".simpleslide100").each(function () {
      var delay = 7000;
      var speed = 1000;
      var itemSlide = window.$(this).find(".simpleslide100-item");
      var nowSlide = 0;

      window.$(itemSlide).hide();
      window.$(itemSlide[nowSlide]).show();
      nowSlide++;
      if (nowSlide >= itemSlide.length) {
        nowSlide = 0;
      }

      setInterval(function () {
        window.$(itemSlide).fadeOut(speed);
        window.$(itemSlide[nowSlide]).fadeIn(speed);
        nowSlide++;
        if (nowSlide >= itemSlide.length) {
          nowSlide = 0;
        }
      }, delay);
    });
    window.$(".js-tilt").tilt({
      scale: 1.1,
    });
  }, []);
  return <ComingSoon />;
}

export default App;
